/*
 * @Author: 
 * @Date: 2024-09-25 10:25:17
 * @LastEditors: 
 * @LastEditTime: 2023-09-17 10:37:29
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { axisLeft } from "d3";
import { toVisualThousands } from "../utils";
import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

function iData(data) {
  let max = Math.max.apply(null, data);
  console.log(max);
  let iData = data.map((item) => {
    return (max - item) / 2;
  });
  return iData;
}

export default ({ label, list = [], color = [] }) => {
  return {
    title: {
      text: "安踏内容篇数分布",
      textAlign: "center",
    },
    color,
    grid: {
      left: '5%',
      top: "9%",
      right: "3%",
      bottom: "3%",
      containLabel: true,
    },

    xAxis: {
      type: "value",
      show: false,
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: { ...xAxisLabelColor },
      max: function (value) {
        return Math.max.apply(null, list);
      },
    },

    yAxis: {
      type: "category",
      data: label,
      inverse: true,
      axisLabel:{
        show: true,
        textStyle: {
          fontWeight: "bold",
          ...yAxisLabelColor,
          // fontSize: 15,
        }
      }, 
      axisLine:{
        lineStyle:{
          color: '#bbb'
        }
      },
      axisTick: { show: false },
      splitLine: { show: false },
    },

    series: [
      {
        name: "辅助",
        type: "bar",
        stack: "总量",
        label: {
          color: "rgba(0,0,0,0)",
        },
        itemStyle: {
          normal: {
            barBorderColor: "rgba(0,0,0,0)",
            color: "rgba(0,0,0,0)",
          },
          emphasis: {
            barBorderColor: "rgba(0,0,0,0)",
            color: "rgba(0,0,0,0)",
          },
        },
        data: iData(list),
      },
      {
        name: "",
        type: "bar",
        stack: "总量",
        barCategoryGap: "15%",
        // data: list,
        data: list.map((item,index) =>{
            return{
              value: item,
              label: {
                textStyle: { color: index === 0 || index === 1 ? '#000' : '#fff' }
              }
            }
        }),
        label: {
          fontSize: 18,
          fontWeight: 550,
          formatter: (ele) => toVisualThousands(ele.value),
      },
        itemStyle: {
          normal: {
            color: color[1],
          },
        },
      },
    ],
  };
};



// WEBPACK FOOTER //
// src/routes/visualChart/P30/chart.js